export const SIGNUP_URL = `/auth/signup`;
export const LOGIN_URL = `/auth/login`;
export const GOOGLE_LOGIN_URL = `/auth/google-login`;
export const EDIT_PROFILE_URL = `/auth/edit-profile`;
export const CHANGE_PASSWORD_URL = `/auth/change-password`;
export const UPLOAD_PIC_URL = `/auth/upload-profile-pic`;

export const CREATE_PROJECT_URL = `/project/create`;
export const GET_PROJECTS_URL = `/project/list`;
export const GET_LATEST_PROJECTS_URL = `/project/latest`;
export const DELETE_PROJECT_URL = `/project/delete`;
export const EDIT_PROJECT_URL = `/project/edit`;

export const CREATE_DOCUMENT_URL = `/document/create`;
export const GET_DOCUMENTS_URL = `/document/list`;
export const DELETE_DOCUMENT_URL = `/document/delete`;
export const EDIT_DOCUMENT_URL = `/document/edit`;

export const GET_PLANS_URL = `/plan/list`;
export const CREATE_SESSION_URL = `/plan/create-session`;

export const GET_USAGE_URL = `/document/usage`;

export const GET_REPORT_URL = `/report/list`;
